import { BaseModal, Button } from '@restworld/ui-ds';
import { ModalWrapperBackIcon, ModalWrapperCloseIcon, getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import 'twin.macro';
import { ModalHeader, ModalSubHeader } from './common';
import tw from 'twin.macro';
import { useDeleteAccountForm } from '../hooks/use-delete-account-form';
import { FlexCol } from './header';
import { useTranslation } from 'next-i18next';

export const DeleteAccountModal = () => {
  const { open, onClose, onOpen, onSubmit, loading } = useDeleteAccountForm();
  const { t } = useTranslation('user-settings');
  const { t: commonT } = useTranslation('common');
  const footer = (
    <FlexCol tw="gap-4 w-full">
      <Button fullwidth={true} variant="danger-with-bg" onClick={onSubmit} loading={loading}>
        {t('delete_account_button_text')}
      </Button>
      <Button fullwidth={true} variant="secondary-outline" onClick={onClose}>
        {commonT('cancel')}
      </Button>
    </FlexCol>
  );
  const header = t('delete_account_modal_header');
  return (
    <>
      <Button variant="danger-ghost" onClick={onOpen}>
        {t('delete_account_modal_button_text')}
      </Button>
      <BaseModal
        {...{
          variant: 'center',
          onClose,
          showMobileGestures: true,
          open,
          title: '',
          modalStyles: [tw`lg:min-w-[24rem] lg:max-w-[24rem]`],
          closeIcon: <ModalWrapperCloseIcon />,
          backIcon: <ModalWrapperBackIcon />,
          footer: footer,
        }}
      >
        <FlexCol tw="items-center">
          <Image src={getAssetSrc('/utils-assets/warning.svg')} width={64} height={64} alt={header} />
          <div tw="flex flex-col items-center justify-start gap-2 mb-6 mt-2">
            <ModalHeader>{header}</ModalHeader>
            <ModalSubHeader>{t('delete_account_modal_subheader')}</ModalSubHeader>
          </div>
        </FlexCol>
      </BaseModal>
    </>
  );
};
